import { termosEnterpriseNegotiationBalanceVersion } from "../routes/pages/legal/content/termosEnterprise";

/**
 * Whether /termos publishes the Saldo de Negociações conditions of this
 * version (termosEnterpriseNegotiationBalanceVersion, section 16 of the
 * Enterprise Terms of Use). The acceptance is offered only when it does,
 * because Payments records the version as the one the company accepted. Any
 * other version, or "", never passes, so no top-up can start under it.
 */
export function isNegotiationBalanceTermsPublished(version: string): boolean {
  return version !== "" && version === termosEnterpriseNegotiationBalanceVersion;
}
